<template>
  <div>
    <basic-container>
      <div id="main" style="width: 65%;height:400px;"></div>
    </basic-container>
  </div>
</template>

<script>
import {
  findProjectProgress,
  findClassifySelect,
  addSystemClassify,
  editSystemClassify,
  delSystemClassify
} from "@/api/salesCloud/saleView";

export default {
  name: "saleView",
  data() {
    return {};
  },
  created() {},
  watch: {},
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    var myChart = echarts.init(document.getElementById("main"));
    // 指定图表的配置项和数据
    myChart.setOption({
      title: {
        text: "近七日收益"
      },
      tooltip: {
        trigger: "axis"
      },
      legend: {
        data: ["近七日收益"]
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      toolbox: {
        // feature: {
        //   saveAsImage: {}
        // }
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: ["2020-3-20", "2020-3-21", "2020-3-22", "2020-3-23", "2020-3-24","2020-3-25","2020-3-26","2020-3-27","2020-3-28","2020-3-29","2020-3-30"]
      },
      yAxis: {
        type: "value"
      },
      series: [
        {
          name: "近七日收益",
          type: "line",
          stack: "总量",
          data: ["1", "2", "3", "4", "5","6","7","0","9","10"]
        }
      ]
    });
    // 异步加载数据
    /*  $.get('data.json').done(function (data) {
                   // 填入数据
                   myChart.setOption({ xAxis: { data: data.categories }, series: [{
                        // 根据名字对应到相应的系列
                        name: '销量',
                        data: data.data
                   }]
                   });});*/
  },
  computed: {},
  props: [],
  methods: {}
};
</script>

<style lang="scss">
</style>
